import Heading from '@ilg-totallymoney/ui/components/Heading'
import Modal from '@ilg-totallymoney/ui/components/Modal'
import Stack from '@ilg-totallymoney/ui/components/Stack'
import Text from '@ilg-totallymoney/ui/components/Text'

import { ModalType } from '@appTypes/EligibilityApi.interface'

import { getRatesAndFeesModalInformation } from './utils/getRatesAndFeesModalInformation'

interface RatesAndFeesModalProps {
    modalType: ModalType | null
    onModalClose: () => void
}

const RatesAndFeesModal = ({
    modalType,
    onModalClose,
}: RatesAndFeesModalProps): React.ReactElement => {
    const {
        title,
        description,
        items = [],
    } = getRatesAndFeesModalInformation(modalType!)

    return (
        <Modal
            isOpen={!!modalType}
            onClose={onModalClose}
            data-testid="ratesAndFeesModal"
            title={title}
            hasTooltipHeader
            isFullScreen
            returnFocusOnClose
        >
            <Stack space="space40">
                {description && <Text color="light">{description}</Text>}

                {items.map((item, i) => (
                    <Stack space="space20" key={`${modalType}-${i}`}>
                        <Heading variant="40">{item.title}</Heading>

                        <Text color="light">{item.description}</Text>
                    </Stack>
                ))}
            </Stack>
        </Modal>
    )
}

export default RatesAndFeesModal
